import React, { useEffect, useState } from 'react';
import { trackEvent } from '../analytics';

// Simple cookie/consent banner informing users about anonymous analytics only.
// No personal data is collected nor stored anywhere.
// Stores acknowledgment in localStorage and does not block app usage.

const STORAGE_KEY = 'cookie_notice_ack_v1';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const ack = typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem(STORAGE_KEY);
      if (!ack) setVisible(true);
    } catch (_) {
      // If localStorage is inaccessible, still show the banner; it will reappear on next load.
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {
      // ignore
    }
    setVisible(false);
    trackEvent('cookie_notice_dismissed');
  };

  if (!visible) return null;

  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie and analytics notice" className="cookie-banner">
      <p>
        We only collect anonymous usage data to analyze how the app is used. No personal data is collected or stored anywhere.
      </p>
      <button onClick={dismiss} aria-label="Dismiss notice">Got it</button>
    </div>
  );
}

export default CookieBanner;
